module.exports = __webpack_public_path__ + "img/n4-press.c809cb3e.png";